import searchState from './searchState';
import * as searchDataLogic from '../../../logic/api/search';
export function onSearchInputChange(searchQuery) {
  return {
    type: 'SEARCH:INPUT-CHANGE',
    searchQuery
  };
}


export const search = (article, detailId) => dispatch => {
  dispatch({
    type: 'SEARCH:RESULTS'
  });

  searchDataLogic.search(article, detailId)
    .then((res) => {
      if (res.error)
        dispatch(searchError(res.err));
      else {
        dispatch(searchSuccess(res));
      }
    })
    .catch((err) => dispatch(searchError(err)));
};

const searchSuccess = (search) => ({
  type: 'SEARCH:RESULTS-SUCCESS',
  search: search
});

const searchError = (err) => ({
  type: 'SEARCH:RESULTS-ERROR',
  err
});



export default function search2Reducer(state = searchState, action) {
  switch (action.type) {
    case 'SEARCH:INPUT-CHANGE':
      return {
        ...state,
        searchQuery: action.searchQuery,
      };
    case 'SEARCH:RESULTS':
      return {
        ...state,
        results:[]
      };
    case 'SEARCH:RESULTS-SUCCESS':
      return {
        ...state,
        results:action.search
      };
    case 'SEARCH:RESULTS-ERROR':
      return {
        ...state,
        Error: action.err
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Search/redux/searchActions.js
 **/